import { drugsRouteStore } from '../domain/store';
import { drugUpdateModalRouteStore } from '../components/drug-update-modal/domain/store';

export default () => {
  drugUpdateModalRouteStore.setInitialState();
  drugsRouteStore.setValue('activeDrugId', null);
  drugsRouteStore.setValue('showingDrugUpdateModal', false);
};
